import { render, staticRenderFns } from "./Versoes.vue?vue&type=template&id=ba0bdd58&scoped=true&"
import script from "./Versoes.vue?vue&type=script&lang=js&"
export * from "./Versoes.vue?vue&type=script&lang=js&"
import style0 from "./Versoes.vue?vue&type=style&index=0&id=ba0bdd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0bdd58",
  null
  
)

export default component.exports